// LEGACY UI: replace with Img (pass preload instead of priority) from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import { type ImgProps, Img as SharedImg } from "@workspace/frontend-ui";

// Thin shim over the shared frontend-ui <Img>. It only exists to preserve the
// casino-specific `priority` alias (the shared component exposes `preload`
// only). All 76 casino consumers import from this path unchanged.
type Props = ImgProps & { priority?: boolean };

const Img: FC<Props> = ({ priority, preload, ...props }) => (
  <SharedImg preload={preload ?? priority} {...props} />
);

export default Img;
